function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { ScrollSyncPane } from 'react-scroll-sync';
import Column from './Column';
import { Checkbox } from '../../Checkbox';
import { Skeleton } from '../../Skeleton';
import styles from '@dtsl/css-data-table/dist/index.module.css';
function Columns(props) {
  const {
    rows,
    columns,
    selectedRows,
    isLoading,
    onHeaderSelect,
    totalResults,
    checkboxSelection,
    leftActionRenderer,
    rightActionRenderer,
    stickyHeader,
    backdropColor,
    selectAllIdentifier
  } = props;
  const selectedRowsLength = selectedRows.length;
  const checkboxVariant = selectedRowsLength === rows.length || selectedRowsLength === totalResults ? 'positive' : 'undetermined';
  const shouldHideHeaderCheckbox = !!columns?.[0]?.noHeaderCheckbox;
  const onChange = event => {
    onHeaderSelect(event.target.checked);
  };
  const getCheckbox = () => /*#__PURE__*/React.createElement(Checkbox, {
    variant: checkboxVariant,
    label: "",
    "aria-label": "master-checkbox",
    checked: selectedRows.length > 0,
    name: "checkbox_name",
    value: "checkbox_value",
    disabled: false,
    onChange: onChange,
    identifier: selectAllIdentifier || 'sibCheckbox_' + checkboxVariant
  });
  const renderActionBar = () => {
    return /*#__PURE__*/React.createElement("td", {
      className: styles['sib-table-actions-container']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['sib-table-left-actions-wrapper']
    }, checkboxSelection && !shouldHideHeaderCheckbox ? getCheckbox() : null, leftActionRenderer()), /*#__PURE__*/React.createElement("div", {
      className: styles['sib-table-right-actions-wrapper']
    }, rightActionRenderer()));
  };
  const headClasses = classNames({
    [styles['sib-data-table__columns']]: true,
    [styles['sib-data-table--sticky-header']]: stickyHeader
  });
  const trClasses = classNames({
    [styles['column-header']]: true,
    [styles['scroller']]: true,
    [styles['syncscroll']]: true
  });
  if (isLoading) {
    return /*#__PURE__*/React.createElement("thead", {
      className: headClasses,
      style: {
        background: backdropColor
      }
    }, /*#__PURE__*/React.createElement("tr", {
      className: trClasses,
      name: "myElements",
      style: {
        display: 'flex'
      }
    }, Array(6).fill(true).map((_, index) => /*#__PURE__*/React.createElement("th", {
      className: styles['sib-skeleton-center'],
      key: index
    }, /*#__PURE__*/React.createElement(Skeleton, {
      height: 24,
      style: {
        borderRadius: '8px'
      }
    })))));
  }
  const renderHeaderCell = (col, index) => {
    return /*#__PURE__*/React.createElement(Column, _extends({
      key: col.field,
      col: col,
      headerIndex: index
    }, props));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, checkboxSelection ? /*#__PURE__*/React.createElement("thead", {
    className: `${headClasses} ${selectedRowsLength === 0 ? styles['hide-columns'] : ''}`,
    style: {
      background: backdropColor
    }
  }, /*#__PURE__*/React.createElement("tr", {
    className: `${styles['column-header']} ${styles['scroller-actions']}`
  }, renderActionBar())) : null, /*#__PURE__*/React.createElement("thead", {
    className: `${headClasses} ${selectedRowsLength > 0 ? styles['hide-columns'] : ''}`,
    style: {
      background: backdropColor
    }
  }, /*#__PURE__*/React.createElement(ScrollSyncPane, null, /*#__PURE__*/React.createElement("tr", {
    className: trClasses,
    name: "data-table-elements"
  }, checkboxSelection ? /*#__PURE__*/React.createElement("th", {
    key: "header-checkbox",
    className: `${styles['header-cell']} ${checkboxSelection ? styles['checkbox-selection'] : ''}`
  }, /*#__PURE__*/React.createElement("span", {
    className: `${shouldHideHeaderCheckbox ? styles['hide-checkbox'] : ''}`
  }, getCheckbox())) : null, columns.map(renderHeaderCell)))));
}
Columns.propTypes = {
  rows: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  selectedRows: PropTypes.array.isRequired,
  totalResults: PropTypes.number.isRequired,
  onHeaderSelect: PropTypes.func.isRequired,
  checkboxSelection: PropTypes.bool.isRequired,
  onColumnItemSelect: PropTypes.func.isRequired,
  leftActionRenderer: PropTypes.func.isRequired,
  rightActionRenderer: PropTypes.func.isRequired,
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  stickyHeader: PropTypes.bool.isRequired,
  backdropColor: PropTypes.string,
  selectAllIdentifier: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
export default Columns;